// A tiny promise-based confirm dialog shared across the app. Call the globally-registered
// `$confirm({ title, message, confirmLabel, cancelLabel, danger })` and await the boolean result;
// the <ConfirmDialog> host (mounted in App.vue) renders the reactive state and resolves the promise.
import { reactive } from 'vue';

export const confirmState = reactive({
    open: false,
    title: '',
    message: '',
    confirmLabel: '',
    cancelLabel: '',
    danger: false,
    resolve: null
});

export function confirm(options = {}) {
    return new Promise((resolve) => {
        confirmState.title = options.title || '';
        confirmState.message = options.message || '';
        confirmState.confirmLabel = options.confirmLabel || '';
        confirmState.cancelLabel = options.cancelLabel || '';
        confirmState.danger = !!options.danger;
        confirmState.resolve = resolve;
        confirmState.open = true;
    });
}

export function settleConfirm(value) {
    if (!confirmState.open) return;
    const resolve = confirmState.resolve;
    confirmState.open = false;
    confirmState.resolve = null;
    if (resolve) resolve(value);
}
